import { useState } from "react";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import { Grain } from "@/components/site/Brand";
import { Preloader } from "@/components/site/Preloader";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { Founder } from "@/components/site/Founder";
import { Lookbook } from "@/components/site/Lookbook";
import { CustomOrders } from "@/components/site/CustomOrders";
import { Marquee } from "@/components/site/Marquee";
import { Contact } from "@/components/site/Contact";

function App() {
  const [, setReady] = useState(false);

  return (
    <LanguageProvider>
      <div className="App relative">
        <Grain />
        <Preloader onDone={() => setReady(true)} />
        <Header />
        <main>
          <Hero />
          <Manifesto />
          <Founder />
          <Lookbook />
          <CustomOrders />
          <Marquee />
          <Contact />
        </main>
      </div>
    </LanguageProvider>
  );
}

export default App;
